import React, {  useEffect, useState } from 'react';
import '../../../../css/assiste.css';
import { ToastContainer } from 'react-toastify';
import { CompanyNameType } from '../../../../static/types/commonTypes/companyNameType';
import { LegalEntityType } from '../../../../static/types/commonTypes/legalEntityType';
import CompanyName from '../../../commonComponents/CompanyName';
import { DecisionType } from '../../../../static/types/commonTypes/decisionType';
import { DateType } from '../../../../static/types/commonTypes/dateType';
import DateComponent from '../../../commonComponents/DateComponent';
import LiquidatorList from './LiquidatorList';
import { LiquidatorManagerType } from '../../../../static/types/creationCloture/liquidatorManagerType';
import { getCityWithPreposition } from '../../../../utils/functions/getCityWithPreposition';
import LegalEntity from '../../../commonComponents/LegalEntity';
import useAppContext from '../../../../hooks/useAppContext';
import { AppContextType } from '../../../../context/AppContext';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import DecisionWithQuality from '../../../commonComponents/DecisionWithQuality';
import { formatObjectText } from '../../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const ClotureDeLiquidation: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
}) => {

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        date, setDate,
        dateValidity, setDateValidity,
        dateChecked, setDateChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,

        liquidators, setLiquidators,
        liquidatorValidity, setLiquidatorValidity,
        liquidatorChecked, setLiquidatorChecked,

        decisionWithQuality,
        setDecisionWithQuality,
        decisionWithQualityValidity,
        setDecisionWithQualityValidity,
        decisionWithQualityChecked,
        setDecisionWithQualityChecked,
        
        lastTab, setLastTab,

    } = useAppContext() as AppContextType

    const [activeTab, setActiveTab] = useState<string>('raisonSociale');
    const [visitedTabs, setVisitedTabs] = useState(['raisonSociale']);

    const goToSupportPresse = () => updateActiveIndex(2);

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validate()) {
            const pluralSubjects = ["Les associés","Les actionnaires"];
            const verb = pluralSubjects.includes(decisionWithQuality.decisionQuality) ? "ont" : "a";
            const managerText = (manager: LiquidatorManagerType) => {
                if (manager.person === "Personne morale") {
                    return manager.entityDetails.companyName ? ` ${manager.entityDetails.companyName}, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}` : ``
                }
                else if (manager.person === "Personne physique") {
                    return manager.personDetails.lastName ? ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}` : ``
                }
            }
            const tempText = `${companyName.companyName}
${legalEntity.legalForm} au capital de ${legalEntity.capital} €,
Siège social : ${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city}
${legalEntity.rcs} RCS ${getCityWithPreposition(legalEntity.registrationOffice)},
${firstPartDecision.includes(decisionWithQuality.decisionNature) ? `Aux termes de l'${decisionWithQuality.decisionNature.toLowerCase()} en date du ${decisionWithQuality.decisionDate} ${decisionWithQuality.decisionQuality} ${verb}` : `Le ${decisionWithQuality.decisionDate}, ${decisionWithQuality.decisionNature.toLowerCase()} ${verb}`} approuvé les comptes de liquidation, donné quitus aux liquidateurs, ${liquidators.map((liquidatorItem: LiquidatorManagerType) => managerText(liquidatorItem)).join(" et ")} pour leur gestion et les a déchargés de leur mandat, et constaté la clôture des opérations de liquidation à compter du ${date.date ? date.date : decisionWithQuality.decisionDate}.
Les comptes de clôture seront déposés au greffe du tribunal de commerce ${getCityWithPreposition(legalEntity.registrationOffice)}.
Radiation au RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.
`
            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
        }
    };

    const firstPartDecision = [
        "AG Extraordinaire",
        "AG Ordinaire",
        "AG Mixte"
    ]

    const handleNext = () => {
        if (activeTab === "raisonSociale") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("raisonSociale"));
            }
        } else if (activeTab === "décision") {
            setDecisionWithQualityChecked(true)
            if (decisionWithQualityValidity) {
                switchTab(getNextTab("décision"));
            }
        } else if (activeTab === "dateeffet") {
            switchTab(getNextTab("dateeffet"));
        } else if (activeTab === "laSociété") {
            setLegalEntityChecked(true)
            if (legalEntityValidity) {
                switchTab(getNextTab("laSociété"));
            }
        } else if (activeTab === "leliquidateur") {
            setLiquidatorChecked(true)
            if (liquidatorValidity) {
                setSubmissive(true)
            }
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };

     
    useEffect(() => {
        // Si on vient d'un brouillon, restaurer l'onglet actif
        if ( lastTab ) {
            setActiveTab(lastTab);
            // Ajouter tous les onglets précédents comme visités
            const tabOrder = ['companyName', 'decision', 'theSociety', 'liquidator', 'liquidationHeadquarter', 'correspondenceAddress' ];
            const currentTabIndex = tabOrder.indexOf(lastTab);
            const visitedTabsArray = tabOrder.slice(0, currentTabIndex + 1);
            setVisitedTabs(visitedTabsArray);
        }
    }, []);

    
    useEffect(() => {
        setLastTab(activeTab);
    }, [activeTab]);

    const getNextTab = (currentTab: string) => {
        if (currentTab === "raisonSociale") return "décision";
        else if (currentTab === "décision") return "dateeffet";
        else if (currentTab === "dateeffet") return "laSociété";
        else if (currentTab === "laSociété") return "leliquidateur";
        else return currentTab;
    };

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "leliquidateur") return "laSociété";
        else if (currentTab === "laSociété") return "dateeffet";
        else if (currentTab === "dateeffet") return "décision";
        else if (currentTab === "décision") return "raisonSociale";
        else return currentTab;
    };

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('raisonSociale')
        }
        else if (!decisionWithQualityValidity) {
            setActiveTab('décision')
        }
        else if (!legalEntityValidity) {
            setActiveTab('laSociété')
        }
        else if (!liquidatorValidity) {
            setActiveTab('leliquidateur')
        }

        return companyNameValidity && decisionWithQualityValidity && legalEntityValidity && liquidatorValidity
    };

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });

    const updateDate = (data: Partial<DateType>) => setDate({ ...date, ...data });

    const updateLegalEntity = (data: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...data });

    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType]

    // Liquidator


    const [submissive, setSubmissive] = useState<boolean>(false)

    const updateDecision = (data: Partial<DecisionType>) => setDecisionWithQuality({ ...decisionWithQuality, ...data });
    

    const tabs =[
        {key: 'raisonSociale', label: 'Raison Sociale'},
        {key: 'décision', label: 'Décision'},
        {key: 'dateeffet', label: "Date d'effet"},
        {key: 'laSociété', label: 'Société concernée par la liquidation'},
        {key: 'leliquidateur', label: 'Le liquidateur'},
    ]
    return (
        <>

                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>

                {
                    activeTab === 'raisonSociale' &&
                    <div>
                        <span>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={updateCompanyName}
                                companyName={companyName}
                                checked={companyNameChecked}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                                showClientReference={true}
                            />
                        </div>

                    </div>

                }

                {
                    activeTab === 'décision' &&
                    <DecisionWithQuality
                        decisionWithQuality={decisionWithQuality}
                        draftFieldName = 'decisionWithQuality'
                        checked={decisionWithQualityChecked}
                        dateLabel='Date'
                        changeDecision={updateDecision}
                        onValidationChange={(isValid: boolean) => setDecisionWithQualityValidity(isValid)}
                        decisionQualityOptions={[
                            "L'associé unique",
                            "Les associés",
                            "Les actionnaires"
                        ]}
                        decisionNatureOptions={[
                            "AG Extraordinaire",
                            "AG Ordinaire",
                            "AG Mixte",
                            "Le gérant",
                            "Le président",
                            "Le conseil d'administration",
                            "Décision unanime des associés"
                        ]}
                    />
                }

                {
                    activeTab === 'dateeffet' &&
                    <DateComponent
                        checked={dateChecked}
                        required={false}
                        date={date}
                        draftFieldName = 'date'
                        dateLabel="A compter du"
                        changeDate={updateDate}
                        onValidationChange={(isValid: boolean) => setDateValidity(isValid)}
                        id='dateCloture'
                    />
                }

                {
                    activeTab === 'laSociété' &&
                    <div>
                        <span>
                            Pour la société, veuillez préciser l'adresse du siège social
                        </span>
                        <div className="tab-content">
                            <LegalEntity
                                companyName={companyName}
                                setCompanyName={(updatedData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...updatedData })}
                                checked={legalEntityChecked}
                                legalEntity={legalEntity}
                                changeLegalEntity={updateLegalEntity}
                                societyType={societyTypeOptions}
                                onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                                draftFieldName = 'legalEntity'
                            />
                        </div>

                    </div>

                }

                {
                    activeTab === 'leliquidateur' &&
                    <div>
                        <>
                            <span>
                                Saisir le nom et l'adresse du ou des liquidateurs
                            </span>
                        </>
                        <div>
                            <LiquidatorList
                                checked={liquidatorChecked}
                                managers={liquidators}
                                addButtonText='Saisir un liquidateur'
                                removeButtonText='Supprimer le dernier liquidateur'
                                labelItem='Liquidateur'
                                setManagers={setLiquidators}
                                setManagersValidity={(isValid: boolean) => setLiquidatorValidity(isValid)}
                            />
                            {
                                submissive &&
                                <div className="mt-4">
                                    <h4>Texte de l'annonce:</h4>
                                    <textarea
                                        className="form-control"
                                        rows={5}
                                        value={txtAnnonce}
                                        disabled
                                    />
                                </div>
                            }
                        </div>
                    </div>
                }

                <div className='button-container'>
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'raisonSociale' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                            )}

                        {
                            activeTab === 'leliquidateur' &&
                            <button type="submit"
                                onClick={handleNext}>
                                Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            activeTab !== 'leliquidateur' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            submissive && activeTab === 'leliquidateur' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}
                    </div>
                </div>
            </form>
        </>
    );
};

export default ClotureDeLiquidation;